var map = {
	"./create.js": "hOND",
	"./edit.js": "6L4I",
	"./index.js": "rvyL",
	"./show.js": "hBY5",
	"./showcards.js": "UoHd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CzvY";


//////////////////
// WEBPACK FOOTER
// ./resources/js/routes/administration/postures nonrecursive .*\.js$
// module id = CzvY
// module chunks = 64 65 66